export default __webpack_public_path__ + "66c5582eb2064d8971b724e035bf202d.png";